<section class="map-marker-widget">
  <google-map height="250px"
    width="100%"
    [center]="center"
    [zoom]="zoom"
    [mapTypeId]="mapTypeId"
    [options]="{disableDefaultUI: true}">
    @for (markerPosition of markerPositions; track markerPosition; let i = $index) {
      @if (markerPosition['type'] && markerPosition['type']=='point' && !markerPosition['dynamic']) {
        <div>
          <map-marker #marker="mapMarker"
            [position]="markerPosition"
            [options]="markerOptions"
            [label]="markerPosition['badge']"
            (mapClick)="openInfoWindow(marker, infoWindow, markerPosition)">
          </map-marker>
          <map-info-window #infoWindow="mapInfoWindow">
            <div class="d-flex flex-column">
              @if (markerPosition['title']) {
                <p class="text-wrap text-break">{{ markerPosition['title']}}</p>
              }
              @if (markerPosition['subtitle']) {
                <span class="text-wrap text-break">{{ markerPosition['subtitle'] }} </span>
              }
              @if (markerPosition['linkURL'] && linkURL[markerPosition['id']]) {
                <a href="{{linkURL[markerPosition['id']]}}" target="_blank" style="color:var(--warmOrange);">
                  <!-- <a *ngIf="markerPosition['linkURL']" href="{{markerPosition['linkURL']}}" target="_blank" style="color:var(--warmOrange);"> -->
                  <span class="material-symbols-outlined">
                    link
                  </span>
                </a>
              }
              @if (markerPosition['directions']) {
                <a href="{{openMapDirection(markerPosition)}}" target="_blank" class="mt-1">
                  <button mat-button class="secondary-gray-button w-100">
                    <mat-icon>open_in_new</mat-icon>{{'pass.map.open_direction' | translate}}
                  </button>
                </a>
              }
              @if (!markerPosition['title'] && !markerPosition['linkURL'] && !markerPosition['subtitle']) {
                <span>...</span>
              }
            </div>
          </map-info-window>
        </div>
      }
      @if (markerPosition['type'] && markerPosition['type']=='line' && !markerPosition['dynamic']) {
        <div>
          <map-polyline [options]="actualPolygonOptions[index]">
          </map-polyline>
        </div>
      }
      @if (markerPosition['type'] && markerPosition['type']=='polygon' && !markerPosition['dynamic']) {
        <div>
          <ng-container>
            <map-polygon #polygon [options]="actualPolygonOptions[index]" (click)="showArrays(polygon)">
            </map-polygon>
          </ng-container>
        </div>
      }
      @if (!markerPosition['type'] && !markerPosition['dynamic']) {
        <div>
          <map-marker #marker="mapMarker"
            [position]="markerPosition"
            [options]="markerOptions"
            [label]="markerPosition['badge']"
            (mapClick)="openInfoWindow(marker, infoWindow, markerPosition)">
          </map-marker>
          <map-info-window #infoWindow="mapInfoWindow">
            <div class="d-flex flex-column">
              @if (markerPosition['title']) {
                <p>{{ markerPosition['title']}}</p>
              }
              @if (markerPosition['subtitle']) {
                <span>{{ markerPosition['subtitle'] }} </span>
              }
              @if (markerPosition['linkURL'] && linkURL[markerPosition['id']]) {
                <a href="{{linkURL[markerPosition['id']]}}" target="_blank" style="color:var(--warmOrange);">
                  <span class="material-symbols-outlined">
                    link
                  </span>
                </a>
              }
              @if (!markerPosition['title'] && !markerPosition['linkURL'] && !markerPosition['subtitle']) {
                <span>...</span>
              }
            </div>
          </map-info-window>
        </div>
      }
    }
  </google-map>
</section>
